import { useTranslation } from 'react-i18next';
import { Button, Stack, Typography } from '@mui/material';
import { StepBox } from '@/components/layout/step-box';
import { Flow } from '@/constants/flow';
import { useFlow } from '@/hooks/use-flow';

export const StepSocialError: React.FC = () => {
  const { t } = useTranslation();
  const { setFlow } = useFlow();

  const handleSignIn = () => {
    setFlow(Flow.LOGIN_STEP_INPUT_USERNAME, {
      resetBiz: true,
    });
  };

  return (
    <StepBox title={t('social_error_title')}>
      <Stack spacing={3}>
        <Typography>{t('social_error_description')}</Typography>

        <Button variant="contained" onClick={handleSignIn}>
          {t('back_to_sign_in')}
        </Button>
      </Stack>
    </StepBox>
  );
};
